export const ESIGN_PRIMARY_SIGNER_COLOR = '#5be8ff';
export const ESIGN_PRIMARY_SIGNER_STROKE_COLOR = '#5CAEFF';

export const ESIGN_SECONDARY_SIGNER_COLOR = '#975bff';

// Keep as a semantic "neutral" token; this maps to a Vuetify/CSS color name in many components.
export const ESIGN_NEUTRAL_COLOR = 'grey';
